module.exports = __webpack_public_path__ + "img/page11.2eab02d9.png";